import MicroModal from 'micromodal';

export default {

	init() {
		console.log('modals init...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		// Inline modals
		$('template[data-js=modal]').each(function (index, elem) {
			var modal = elem.content.firstElementChild.cloneNode(true);
			document.body.appendChild(modal);
		});

		// Video modals
		$('[data-modal-video]').each(function (index, elem) {
			var modal = Modals.createVideoModal(elem);
		});

		// Video modal sliders
		$('[data-modal-video-gallery]').each(function (index, elem) {
			var modal = Modals.createVideoGallery(elem);
		});

		// Open company modal on page load
		if ($('#modal-company').length) {
			console.log('company');
			var modalTimer = setTimeout(function(){
				MicroModal.show('modal-company', {
					onShow: Modals.show,
					onClose: Modals.close,
					disableFocus: true,
					disableScroll: true
				});
			}, 3000);
		}

		// Initialize all modals
		if (!$('[data-micromodal-trigger]').length) {
			return;
		}

		$('[data-micromodal-trigger]').on('click', function (e) {
			e.preventDefault();
		});

		$('[micromodal-target]').on('click', function (e) {
			e.preventDefault();

			const target = $(this).attr('micromodal-target');

			MicroModal.show(target, {
				onShow: Modals.show,
				onClose: Modals.close,
				disableFocus: true,
				disableScroll: true
			});
		});

		MicroModal.init({
			onShow: Modals.show,
			onClose: Modals.close,
			disableFocus: false,
			disableScroll: true,
			debugMode: true
		});
	},

	show(modal, trigger, event) {	
		$('html').addClass('has-modal-open').addClass('is-modal-open');

		let triggerElement = event.currentTarget;

		// Check for starting slide
		if (triggerElement.hasAttribute('data-slide')) {
			let start = triggerElement.getAttribute('data-slide');
			let slider = $(modal).find('.slider-video').data('slider');
			slider.go(`>${start}`).refresh();
		}

		$('.autoplay-hero-video').each(function(){
			this.pause();
		});

		$('.accordion-images .accordion-image-toggle:not(.hidden) video').each(function(){
			this.pause();
		});
	},

	close() {
		$('html').removeClass('has-modal-open').removeClass('is-modal-open');

		// Stop video
		Video.stopAllVideos();

		$('.autoplay-hero-video').each(function(){
			if(this.paused && Video.isElInFrame(this)) this.play();
		});

		$('.accordion-images .accordion-image-toggle:not(.hidden) video').each(function(){
			if(this.paused && Video.isElInFrame(this)) this.play();
		});
	},

	// Create a modal with a single video
	createVideoModal(elem) {
		const url = elem.getAttribute('data-video-url');
		const aspect = elem.getAttribute('aspect');

		let content;
		if(aspect.length) {
			content = Video.getVideoEmbed(url, aspect);
		} else {
			content = Video.getVideoEmbed(url);
		}

		let modalId = Modals.generateId('modal-');
		Modals.create(content, modalId);
		elem.setAttribute('data-micromodal-trigger', modalId);
	},

	// Create a modal with video gallery
	createVideoGallery(elem) {
		let elems = elem.querySelectorAll('[data-video-url]');
		let modalId = Modals.generateId('modal-');
		let sliderId = Modals.generateId('slider-');
		let thumbsId = Modals.generateId('thumbs-');


		// Main slider
		let sliderHtml = `<div class="splide slider slider-video" id="${sliderId}" data-splide-ignore><div class="splide__track"><div class="splide__list flex">`;
		Array.from(elems).forEach((elem, index) => {
			let childClick = '';
			if(elem.getAttribute('child-micromodal-click')) childClick = elem.getAttribute('child-micromodal-click');

			elem.setAttribute('data-slide', index);
			elem.setAttribute('data-micromodal-trigger', modalId);
			let aspect = elem.getAttribute('aspect');
			console.log(elem.getAttribute('data-video-url'));
			console.log(aspect);
			sliderHtml += '<div class="splide__slide w-full">'+  Video.getVideoEmbed(elem.getAttribute('data-video-url'), aspect) +'</div>';

			if(childClick.length) {
				$('#' + childClick).each(function(){
					this.setAttribute('data-micromodal-trigger', modalId);
				});
			}
		});
		sliderHtml += '</div></div></div>';

		// Thumbnails
		sliderHtml += `<div class="splide slider slider-thumbs" id="${thumbsId}" data-splide-ignore><div class="splide__track"><div class="splide__list flex">`;
		Array.from(elems).forEach((elem) => {
			let imageUrl = elem.getAttribute('data-video-poster');
			sliderHtml += `<div class="splide__slide aspect-video"><img src="${imageUrl}" class="block w-full h-full object-cover" alt=""></div>`;
		});
		sliderHtml += '</div></div></div>';

		// Create
		Modals.create(sliderHtml, modalId);
		Sliders.initGallery(sliderId, thumbsId);
	},

	// Create modal element
	create(content, id) {
		let template = `
			<div class="modal modal-video micromodal-slide" id="${id}" aria-hidden="true">
				<div class="modal__overlay" tabindex="-1" data-micromodal-close>
					<button class="modal__close btn-round" aria-label="Close modal" data-micromodal-close>
						<span class="sr-only">Close</span>
						<svg data-micromodal-close height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg"><path d="m20 10c.5522847 0 1 .4477153 1 1v8h8c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1h-8v8c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-8h-8c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h8v-8c0-.5522847.4477153-1 1-1z" fill="currentColor" fill-rule="evenodd" transform="matrix(.70710678 .70710678 -.70710678 .70710678 20 -8.284271)"/></svg>
					</button>
					<div class="modal__container container" role="dialog" aria-modal="true">
						${content}
					</div>
				</div>
			</div>
		`;

		let modal = new DOMParser().parseFromString(template, 'text/html').body.firstChild;
		document.body.appendChild(modal);
	},

	// Generate a unique ID
	generateId(prefix = '') {
		return prefix + (new Date().getTime()) + (Math.random().toString(16).substring(2));
	}

};
